import { Tutor } from '../../objetos/objeto_tutor';
import React, { useMemo, useState } from 'react';
import { tutoresApi } from '../../services/api';
import { toast } from 'react-toastify';
import { useLoading } from '../../utils/LoadingProvider';
import { getSocket } from '../../services/socket';

export const useTutoresModel = () => {
    const {withLoading } = useLoading();
    const [formularioEnviado, setFormularioEnviado] = useState(false);
    const [tutoresBusqueda, setTutoresBusqueda] = useState([]);

    const [tutores, setTutores] = useState();
    const [loadingTUtores, setLoading] = useState();
    const [errorTutores, setError] = useState();
    const [nuevoTutor, setNuevoTutor] = useState({
        nombreCompleto: '',
        numeroWhatsapp: '57',
        tipoDocumento: '',
        identificacionTutor: '',
        correogmail: '',
        formacionAcademica: '',
        carrera: '',
        universidad: '',
        paisOrigen: '',
        ciudadOrigen: '',
        contrasena: '',
        confirmarContrasena: '',
        aceptoTerminos: false
    });

    //prospectos
    const [prospectos, setprospectos] = useState();
    const [loadingprospectos, setLoadingprospectos] = useState();
    const [errorprospectos, setErrorprospectos] = useState();

    //administradores y colaboradores
    const [colaboradores, setcolaboradores] = useState();
    const [loadingcolaboradores, setLoadingcolaboradores] = useState();
    const [errorcolaboradores, setErrorcolaboradores] = useState();

    const [tutor, setTutor] = useState();
    const [loaadingTutor, setLoadingTutor] = useState();

    /**
     * @param {Object} props - Propiedades del componente
     * @param {Tutor} props.tutor - La solicitud a renderizar
     */
    const addNewProspectoTutor = async(tutorData) =>{
      return withLoading(async () =>{

        console.log("informacion",tutorData);
        const contrasena = tutorData.contrasena;

        // Validación de que contraseña y confirmarContraseña sean iguales
        if (contrasena !== tutorData.confirmarContrasena) {
            toast.error("Error: Las contraseñas no coinciden");
            return false;  // Detiene la ejecución si las contraseñas no coinciden
        }

        try{
            const processedTutorData = {
              ...tutorData,
              numeroWhatsapp: parseInt(tutorData.numeroWhatsapp, 10)
            };
            const tutorObj = new Tutor(processedTutorData);

            const tutorDataJson = tutorObj.toMap();
            console.log("json ",tutorDataJson);

            //numerowhatsapp.lenght <=5 , muy corto     

            const respuesta = await tutoresApi.createProspecto(tutorDataJson,contrasena);

            
            if (respuesta.success) {
                toast.success(`Exito: ${respuesta.message}`);

                // Limpiar el formulario después de crear exitosamente
                setNuevoTutor({
                    nombreCompleto: '',
                    numeroWhatsapp: '57',
                    tipoDocumento: '',
                    numeroDocumento: '',
                    correogmail: '',
                    formacionAcademica: '',
                    carrera: '',
                    universidad: '',
                    paisOrigen: '',
                    ciudadOrigen: '',
                    contrasena: '',
                    confirmarContrasena: '',
                    aceptoTerminos: false
                });

                setFormularioEnviado(true); // <-- Aquí se corrigió el nombre
                return true;
            } else {
                toast.error(`Error: ${respuesta.message}`);
                return false;
            }

        }
        catch(error){
            console.error('Error al añadir prospecto:', error);
            toast.error("Error, " + error.response.data.error);
            return false;
        }
      
      });
    }
    // Función nuevo tutor corregida
    const handleChange = (e, selectedOption = null) => {
      if (selectedOption !== null) {
        const { name } = selectedOption;
        const value = selectedOption.value || '';

        setNuevoTutor(prevState => ({
          ...prevState,
          [name]: value,
        }));
      } else {
        const { name, value, type, checked } = e.target;

        if (name === 'numeroWhatsapp' || name === 'numeroDocumento') {
          // Filtrar solo números para los campos numéricos
          const numericValue = value.replace(/[^0-9]/g, '');
          setNuevoTutor(prevState => ({
            ...prevState,
            [name]: numericValue
          }));
        } else {
          // Para el resto de campos
          setNuevoTutor(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
          }));
        }
      }
    };

    //componente para agregar informacion de tutor
    const addRegistroCompletoTutor = async(tutorDataFaltante,usuario) =>{
      return withLoading(async () =>{
        console.log("tenemos info ",usuario);
        const archivoHojaVida = tutorDataFaltante.hojaVida;
        const archivoFotoPerfil =  tutorDataFaltante.fotoPerfil;

        //no hace falta convertir

        if(tutorDataFaltante.tipoServicios.length === 0){
          toast.error("Error: Debes seleccionar los tipos de servicios que manejas");
          return false;
        }

        if(tutorDataFaltante.materias.length === 0){
          toast.error("Error: Debes seleccionar las materias que manejas, al menos una");
          return false;
        }

        if(tutorDataFaltante.cuentas.length === 0){
          toast.error("Error: Debes agregar tus cuentas bancarias, al menos una");
          return false;
        }

        if(tutorDataFaltante.hojadevida === null){
          toast.error("Error: Debes agregar tu hoja de vida");
          return false;
        }

        if(tutorDataFaltante.fotoPerfil === null){
          toast.error("Error: Debes subir una foto de perfil");
          return false;
        }

        try{

          //const tutorObj = new Tutor(usuario);

          const tutorDataJson = usuario.toJson();

          const respuesta = await tutoresApi.addRegistroCompletoProspecto(tutorDataFaltante,tutorDataJson);

          if(respuesta.success){
            toast.success(`Exito: ${respuesta.message}`);
            return true;
          }else{
            toast.error(`Error: ${respuesta.message}`);
            return false;
          }

        }
        catch(error){
          console.log("tenemos un error al registrar el tutor completamente",error);
          return false;
        }
        
      },'Procesando Cotizacion...');
    }

    //cargar tutores
    const cargarTutores = async() =>{
      try {
        setLoading(true);
        setError(null);
        console.log("cargando tutores");
        
        const response = await tutoresApi.getTutores();
        
        console.log("cargado de tutor",response);
        // Convertir cada elemento del array data a objeto Tutor
        const data = response.data;
        const tutores_obj = data.map(tutorData => Tutor.fromJson(tutorData));
        
        console.log("se obtuvieron",tutores_obj.length);
        // Establecer la lista de tutores en el estado
        setTutores(tutores_obj);
        
      } catch(error) {
        setError('Error al cargar los tutores: ' + error.message);
      } finally {
        setLoading(false);
      }
    }
    //tutores options
    const tutoresOptions = useMemo(() =>{

      if(!tutores || tutores.length === 0){
        return [];
      }
      

      return tutores
        .filter(tutor => tutor.activo) 
        .map(tutor => ({
          value: tutor.nombrewhatsapp,
          label: tutor.nombrewhatsapp,
          tutor: tutor,
        }));


    }, [tutores]); 

    //cagar prospectos
    const cargarProspectos = async() =>{
      try{
        setLoadingprospectos(true);
        setError(null);
        console.log("cargar prospectos");

        const response = await tutoresApi.getProspectos();
        
        const data = response.data;
        const tutores_obj = data.map(tutorData => Tutor.fromJson(tutorData));

        setprospectos(tutores_obj);
      }
      catch(error){
        setErrorprospectos('Error al cargar los prospectos: ' + error.message);
      }
      finally{
        setLoadingprospectos(false);
      }
    }
    //cargar admins
    const cargarColaboradores = async(nombreEmpresa) =>{
      try{
        setLoadingcolaboradores(true);
        setErrorcolaboradores(null);
        console.log("cargando colaboradores");

        const response = await tutoresApi.getColaboradores(nombreEmpresa);

        const data = response.data;
        const tutores_obj = data.map(tutorData => Tutor.fromJson(tutorData));

        setcolaboradores(tutores_obj);
      }
      catch(error){
         setErrorcolaboradores('Error al cargar los colaboradores: ' + error.message);
      }
      finally{
        setLoading(false);
      }
    }

    //cargar tutores por materia
    const cargarTutoresPorMateira = async(materia) =>{
      try{
        setLoading(true);
        const response = await tutoresApi.getTutoresporMateria(materia);
        const dataConvertida = Object.values(response);
        const tutoresObj = dataConvertida.map(item => Tutor.fromJson(item));

        setTutoresBusqueda(tutoresObj);
        setError(null);

        return tutoresObj;
      }
      catch(error){
        console.error("Error detallado en tutores por materia:", error);
        setError(error.message || "Error al cargar tutore por materia");
      }
      finally{
        setLoading(false);
      }
    }
    //tutores por materia optiones
    const tutoresPorMateriaOptions = useMemo(() =>{

      if(!tutoresBusqueda || tutoresBusqueda.length === 0){
        return [];
      }

      return tutoresBusqueda.map(tutor => ({
        value: tutor.nombrewhatsapp,
        label: tutor.nombrewhatsapp,
        tutor: tutor,
      }));


    }, [tutoresBusqueda]); 

    //cargar tutor
    const cargarTutorPorUid = async(uid) =>{
      console.log("a cargar tutor con uid",uid);
      try{
        setLoadingTutor(true);
        const data = await tutoresApi.getById(uid);
        const tutorData = Tutor.fromJson(data.data);
                console.log("cargando tutor data modelo ",tutorData);
        setTutor(tutorData);
        setError(null);
        return tutorData;
      }
      catch(error){
        console.error("Error al obtener tutor:", error);
        setError(error.message || "Error al cargar el tutor");
        return null;
      }
      finally{
        setLoadingTutor(false);
      }
    }

    //update tutor
    const updateTutor = async(uidTutor,nombreEmpresa,field,valor,type = 'field') =>{
      return withLoading(async() =>{
        let finalUpdateData = {};

        if(!field ){
          toast.error("Este error no deberia salir");
          return;
        }

        if(type == "field" ){
         const datosParaValidar = { [field]: valor };
          const tutorTemporal = new Tutor({});
          tutorTemporal.updateFromJson(datosParaValidar);
          console.log("el tutor temporal",tutorTemporal);
          const valorConvertido = tutorTemporal.getFieldValue(field);
        
          finalUpdateData = {
            [field]: valorConvertido
          };
          console.log("a actualziar tutor",valorConvertido,valor);
        }
        else if(type == "array"){
          finalUpdateData = {             
            field: field,             
            data: valor
          }
        }
        else if(type == "array_insert"){
          finalUpdateData = {             
            field: field,             
            data: valor
          }
        }

        try{
          console.log("antes de enviar final",finalUpdateData);
           const respuesta = await tutoresApi.updateTutor(nombreEmpresa,uidTutor,type,finalUpdateData);

          if (respuesta.success) {
            toast.success(`Exito: ${respuesta.message}`);
          } else {
            toast.error(`Error: ${respuesta.message}`);
          }

        }
        catch(error){
          console.error('Error al actualizar el tutor', error);
          toast.error("Ocurrió un error a actualizar el tutor: " + (error.message || "Error desconocido"));
          return { success: false, error: error };
        }

      },'Actualizando tutor')
    }

    //obtener estadisticas de tutor
    const obtenerEstadisticasTutor = async(nombreTutor) =>{
      try{

        const response = await tutoresApi.getEstadisticaTutor(nombreTutor);

        return response;

      }
      catch(error){
        console.error("Error al obtener estadisticas del tutor:", error);
        setError(error.message || "Error al cargar las estadisticas de tutor");
        return null;
      }
    }

    //generar prueba para prospecto
    const generarPruebaProspectoLocal = (materiasSeleccionadas,uidTutor) =>{
      return withLoading(async () =>{
        try{

          if (!materiasSeleccionadas || materiasSeleccionadas.length !== 3) {

            toast.error("Error: Debes seleccionar exactamente 3 materias.");
            console.warn("Intento de generar prueba con un número incorrecto de materias:", materiasSeleccionadas);
            
            return false;
          }
          
          const respuesta = await tutoresApi.generarPruebaProspecto(materiasSeleccionadas,uidTutor);

          if (respuesta.success) {
                toast.success(`Exito: ${respuesta.message}`);

                return true;
            } else {

                toast.error(`Error: ${respuesta.message}`);

                return false;
            }

        }
        catch(error){
          console.error('Error al generar prueba', error);
          toast.error("Ocurrió un error al generar prueba: " + (error.message || "Error desconocido"));
          return { success: false, error: error };
        }
          
      },'Generando prueba, por favor espere');
    }

    //entregar examen Tutor
    const entregarExamenPruebaProspecto = (uid, archivos, totalExamenes) => {
    // La función 'withLoading' debe ser llamada con la función asíncrona
    // y el mensaje como dos argumentos separados por una coma DENTRO de los paréntesis.
    return withLoading(async () => {
        try {
            const respuesta = await tutoresApi.entregaExamenProspecto(uid, archivos, totalExamenes);
            
            console.log("Respuesta de la API recibida.");
            toast.success(respuesta.message || "Examen entregado con éxito");

            return true; // Indicar que la operación fue exitosa

        } catch (error) {
            console.error("Error al entregar los exámenes:", error);
            // Asegúrate de mostrar un mensaje de error útil
            const errorMessage = error.response?.data?.message || error.message || 'Ocurrió un error desconocido';
            toast.error(`Error: ${errorMessage}`);
            
            return false; // Indicar que la operación falló
        }
    }, 'Entregando examen ...'); // <-- La coma y el mensaje van aquí dentro
    }

    //sockets
    const setupWebSocketTutores = (tutorObjeto, nombreEmpresa) =>{
      if (!tutorObjeto) return;

      const socket = getSocket();

      const handleTutorUpdate = (data) =>{
        console.log("obteniendo actualziacion de tutor",data.tutorData.uid,data.tutorData.uid == tutorObjeto.uid);
        if(data.tutorData.uid == tutorObjeto.uid) {
          const tutorActualizado = Tutor.fromJson(data.data);
          setTutor(tutorActualizado);
        }
      };

      if(tutorObjeto !== null){
        //a escuchar tutor
        socket.emit('join-tutor', {uidTutor: tutorObjeto.uid , nombreEmpresa: nombreEmpresa});

        //regisdtrar listener de cliente id
        socket.on('tutor:uidTutor',handleTutorUpdate);
      }

      return () =>{
        //Dejar de escuchar a tutor
        socket.emit('leave-tutor', {idTutor: tutorObjeto.uid , nombreEmpresa: nombreEmpresa});
        //Eliminar listeners
        socket.off('tutor:uidTutor', handleTutorUpdate);
      }


    }

    return{
        nuevoTutor,
        handleChange,
        addNewProspectoTutor,
        addRegistroCompletoTutor,
        formularioEnviado,

        tutores,
        loadingTUtores,
        errorTutores,
        cargarTutores,
        tutoresOptions,
        
        //tutores por materia
        cargarTutoresPorMateira,
        tutoresBusqueda,
        tutoresPorMateriaOptions,

        //tutor solitario
        tutor,
        cargarTutorPorUid,
        loaadingTutor,
        obtenerEstadisticasTutor,

        //actualizar tutor 
        updateTutor,

        //prospectos
        cargarProspectos,
        prospectos,
        loadingprospectos,
        errorprospectos,
        generarPruebaProspectoLocal,

        //colaboradores
        cargarColaboradores,
        colaboradores,
        loadingcolaboradores,
        errorcolaboradores,

        //web socket
        setupWebSocketTutores,

        entregarExamenPruebaProspecto,
    }

}